import LoggedInUser from './LoggedInUser'

class Helpers {
    static backendURL = process.env.REACT_APP_BACKEND_URL || "http://localhost:3000";
    static frontendURL = process.env.REACT_APP_FRONTEND_URL || "http://localhost:3001";
    static endpoint = (e) => (Helpers.backendURL + e);
    static imageURL = function(img, size = 400) {
        if (/[?]+/.test(img)) {
            return img + '&size=' + size
        } else {
            return img + '?size=' + size
        }
    }
    static defaultThumbnail = "http://sites.austincc.edu/biotech/wp-content/uploads/sites/71/2015/04/person-placeholder.jpg";
}

export function handleHttpResponse(response) {
    const promise = new Promise(function(resolve, reject) {
        if (!response.ok) {
            response.json().then(function(result) {
                if ('message' in result) {
                    reject(result.message)
                } else {
                    reject("There was an error performing this action, please try again.")
                }
            });
        } else {
            response.json().then((r) => resolve(r));
        }
    })
    return promise;
}

/**
 * @deprecated We removed SF so we have no assignee right now because it depended on SF
 * @returns {Promise<{salesforce_users: *[]}>}
 */
export async function salesforce_users() {
    return { salesforce_users: [] }
    //const response = await fetch(Helpers.endpoint("/salesforce_user_list?auth_token=" + LoggedInUser.getInfo().auth_token), {
    //    method: 'GET',
    //    headers: {
    //        'Accept': 'application/json',
    //        'Content-Type': 'application/json',
    //    }
    //})
    //return response.json()
}

/**
 * @deprecated not used
 */
export function profileTypes() {
//    return fetch(Helpers.endpoint("/valid_profiles?auth_token=" + LoggedInUser.getInfo().auth_token), {
//        method: 'GET',
//        headers: {
//            'Accept': 'application/json',
//            'Content-Type': 'application/json',
//        }
//    }).then((response) => response.json())
}

export default Helpers;